"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var base_1 = tslib_1.__importDefault(require("../base"));
var DepositAccountResource = /** @class */ (function (_super) {
    tslib_1.__extends(DepositAccountResource, _super);
    function DepositAccountResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DepositAccountResource.endpoint = '/depositaccounts';
    DepositAccountResource.MODEL_NAME = 'depositaccount';
    return DepositAccountResource;
}(base_1.default));
exports.default = DepositAccountResource;
//# sourceMappingURL=depositaccount.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@sigmacloud/sigma-client/dist/resources/system/depositaccount.js
// module id = DfQ1
// module chunks = 0